<template>
  <div  class="tooltip" @click.self="$emit('close')">
    <ul>
      <li @click="$router.push(item.src)" v-for="(item , index) in innerPage" :key="index">
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "the-tooltip-navbar",
  data() {
    return {
      innerPage: [
        {name: 'بلاگ', src: ''},
        {name: '  راهنمای سایت', src: '/guide'},
        {name: 'درباره ما', src: '/about'},
        {name: ' تماس با ما', src: '/contact'},
        {name: ' سوالات متداول', src: '/qa'},
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip {
  width: 130px;
  height: 234px;
  background-color: #0B1426;
  padding: 16px 0;
  border-radius: 8px;
  margin-top: 20px;
  z-index: 10;
  position: absolute;

  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 23px;

    li {
      list-style: none;
      color: #D7C8C8;
      font-size: clamp(14px, 2vw, 16px);
      &:hover{
        color: #FBFBFD;
      }
    }
  }
}
</style>